import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { jsx } from '../../../jsx';
import Rect from './rect';
import Polar from './polar';
export default (function (props) {
  var coord = props.coord;
  var coordType = coord.type; // 直角坐标系

  if (coordType === 'rect') {
    return jsx(Rect, _objectSpread({}, props));
  } // 极坐标系


  return jsx(Polar, _objectSpread({}, props));
});